export default __webpack_public_path__ + "static/media/levelshoes.92a6f890.png";